import { HeartHandshake } from "lucide-react";

export function Team() {
	const organizations = [
		"Microsoft",
		"TikTok",
		"Jane Street",
		"Carnegie Mellon University",
	];

	return (
		<section id="team" className="relative overflow-hidden py-16 sm:py-20">
			<div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_bottom,_rgba(15,157,138,0.22),_transparent_65%)]" />
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="glass-panel mx-auto max-w-4xl rounded-[28px] border border-white/70 px-8 py-10 text-center shadow-lg shadow-primary/10 backdrop-blur-xl">
					<div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
						<HeartHandshake className="h-6 w-6" />
					</div>
					<h3 className="text-2xl font-semibold sm:text-3xl">
						Built by a team from missions you already trust
					</h3>
					<p className="mx-auto mt-4 max-w-2xl text-sm text-muted-foreground sm:text-base">
						We have managed community developer programs and helped open source
						teams stay vibrant for years. Squash is how we bottle that magic for
						you.
					</p>
					<div className="mt-8 flex flex-wrap items-center justify-center gap-3">
						{organizations.map((org) => (
							<span
								key={org}
								className="rounded-full border border-white/70 bg-white/70 px-5 py-2 text-sm font-semibold text-foreground shadow-sm shadow-primary/10 backdrop-blur"
							>
								{org}
							</span>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
